import React, { useState, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
  Divider,
  Grid,
  Header,
  Segment,
  Table,
  Button,
  Modal,
  Icon,
  Accordion,
  Input,
  Form,
  Popup,
  // TextArea,
  Checkbox
} from 'semantic-ui-react';
import {
  copyToClipboard,
  commandToText,
  isV2LanceID,
  displayLanceID,
  linkifyText,
  // getOrionReporter,
  dbUTCDatetimeToLocal2
} from '../../utils';
import { servicesAPI } from '../../_services/services_api';
import { useCurrentUser } from '../../_services';
import { setToast } from '../../store/ToastManagement';
import { dbUTCTimeToLocal, dbUTCDatetimeToLocal } from '../../utils';
import { ChargingSessionStates } from './ChargingSessionStates';
import Moment from 'moment-timezone';
import { extendMoment } from 'moment-range';
import './Map.css';

const moment = extendMoment(Moment);

const dataRequestOptions = [
  { text: 'Cartridge UID', value: 0 },
  { text: 'Pre-authorised lance UID 1', value: 1 },
  { text: 'Pre-authorised lance UID 2', value: 2 },
  { text: 'Pre-authorised lance UID 3', value: 3 },
  { text: 'Repeat last Transaction Request', value: 4 }
];

const ledCartridgeLanceOptions = [
  { text: 'Cartridge', value: 0 },
  { text: 'Lance', value: 1 }
];

const ledCartidgeSetOptions = [
  { text: 'Middle', value: 0 },
  { text: 'Edge', value: 1 }
];

const ledLanceSetOptions = [
  { text: 'RGB', value: 0 },
  { text: 'White', value: 1 }
];

const ledColourOptions = [
  { text: 'Off', value: 0 },
  { text: 'Red', value: 1 },
  { text: 'Green', value: 2 },
  { text: 'Yellow', value: 3 },
  { text: 'Blue', value: 4 },
  { text: 'Magenta', value: 5 },
  { text: 'Cyan', value: 6 },
  { text: 'White', value: 7 }
];

const ledSolidFlashingOptions = [
  { text: 'Solid', value: 0 },
  { text: 'Flashing', value: 1 }
];

const settingTypeOptions = [
  { text: 'Programmed lance UID 1', value: 0 },
  { text: 'Programmed lance UID 2', value: 1 },
  { text: 'Programmed lance UID 3', value: 2 },
  { text: 'HOME house limit', value: 3 }
];

const toHex = (value, digits) => value.toString(16).padStart(digits, '0');

export const DisplayCS = ({ history, location }) => {
  const hubRef = location.pathname.split('/')[3];
  const csId = location.pathname.split('/')[4];
  const phalanxRef = hubRef + '_' + csId;

  const [phalanx, setPhalanx] = useState(null);
  const [hydra, setHydra] = useState(null);
  const [lance, setLance] = useState(null);
  const [isAXON, setIsAXON] = useState(false);
  const [isAON, setIsAON] = useState(false);
  const [isLanceV2, setIsLanceV2] = useState(false);
  const [dataRequest, setDataRequest] = useState(0);
  const [ledCartridgeLance, setLedCartridgeLance] = useState(0);
  const [ledSet, setLedSet] = useState(1);
  const [ledColour, setLedColour] = useState(0);
  const [ledSolidFlashing, setLedSolidFlashing] = useState(0);
  const [ledOnTime, setLedOnTime] = useState(0);
  const [ledOffTime, setLedOffTime] = useState(0);
  const [ledBrightness, setLedBrightness] = useState(60);
  const [modemPowerDownExpiryTimer, setModemPowerDownExpiryTimer] = useState(0);
  const [operatorCode, setOperatorCode] = useState(0);
  const [permanent, setPermanent] = useState(false);
  const [settingType, setSettingType] = useState(0);
  const [settingPermanent, setSettingPermanent] = useState(false);
  const [settingLength, setSettingLength] = useState(12);
  const [settingValue, setSettingValue] = useState('');
  const { currentUser, currentUserCan, currentUserIsDebug } = useCurrentUser();
  const [charging, setCharging] = useState(false);
  const [tableData, setTableData] = useState([]);
  const [messageByteStringValid, setMessageByteStringValid] = useState(false);
  const [messageByteString, setMessageByteString] = useState('');
  const [messageLength, setMessageLength] = useState(0);
  const [command, setCommand] = useState('');
  const [params, setParams] = useState([]);
  const [rerouteCommand, setRerouteCommand] = useState(false);
  const [confirmation, setConfirmation] = useState('');
  const [isModalOpen, setIsModalOpen] = useState(false);
  // const [customer, setCustomer] = useState(null);
  const [what, setWhat] = useState('');
  const [who, setWho] = useState(null);
  const [where, setWhere] = useState('');
  const [statusHide, setStatusHide] = useState(false);
  const [orionsHide, setOrionsHide] = useState(true);
  const [statesHide, setStatesHide] = useState(false);
  const [lanceDetected, setLanceDetected] = useState(false);
  const [lastUpdated, setLastUpdated] = useState('');
  const [orionTypes, setOrionTypes] = useState(null);
  const [orions, setOrions] = useState(null);
  // const [orionNotes, setOrionNotes] = useState('');
  const [refresh, setRefresh] = useState(false);

  const dispatch = useDispatch();

  const NO_UID = '00000000-0000-0000-0000-000000000000';

  // const displayMessage = (title, message, success) =>
  //   dispatch(
  //     setToast({
  //       title: title,
  //       success: success,
  //       body: message
  //     })
  //   );

  const getHydra = () => {
    servicesAPI.InventoryServices('getHydra', phalanx.hydra_tag_id, false).then(
      hydra => {
        setHydra(hydra);
      },
      error => {}
    );
  };

  const getWhoWhatWhere = (hydra, phalanx) => {
    const parts = phalanx.reference.split('_');
    const csId = parts[parts.length - 1];
    setWhere(`${hydra.description} CS${csId}`);

    // setCustomer(null);
    setWho('');
    const lanceTagId = phalanx.connected_lance_tag_id;
    if (lanceTagId && lanceTagId !== NO_UID) {
      const values = {
        tag_ids: [lanceTagId]
      };

      servicesAPI
        .CustomerServices('getCustomerNamesFromLanceTagIds', values)
        .then(
          customers => {
            const customer = customers.find(c => c.lance_tag_id === lanceTagId);

            if (customer) {
              const customerName = customer
                ? customer.forename + ' ' + customer.surname
                : 'Unknown customer';

              // setCustomer(customer);
              setWho(customerName);
              setWhat(`(${customerName} is actively charging)`);

              servicesAPI.CustomerServices('getPreferences', customer.id).then(
                preferences => {
                  if (preferences.pref_charging_type) {
                    const delayedOrSmartCharging = ['Cheapest'].includes(
                      preferences.pref_charging_type
                    );
                    if (delayedOrSmartCharging)
                      setWhat(
                        `(${customerName} is actively charging and has selected delayed (23:30 to 06:30) charging)`
                      );
                  }
                },
                error => {}
              );
            }
          },
          error => {}
        );
    }
  };

  const displayState = p => {
    if (p.current_state === 'DisabledState') {
      return <p style={{ color: 'red' }}>{p.current_state}</p>;
    }

    if (p.axon_stopped) {
      return (
        <p style={{ color: 'red' }}>
          {p.current_state}
          <br />
          (AXON stopped CS to prevent lance theft)
        </p>
      );
    }

    return p.current_state;
  };

  async function getData(phalanx_tag_id, meter_tag_id) {
    try {
      const readings = await servicesAPI.MeteringServices(
        'getReadings',
        meter_tag_id,
        1
      );

      const reading = readings[0];

      const commissioning = phalanx.tag_status === 'COMMISSIONING';
      const maintenance = phalanx.tag_status === 'MAINTENANCE';
      const capped = phalanx.status === 'Capped';
      const muted = phalanx.status === 'Stopped';
      const faulted = phalanx.status === 'Faulted';
      const charging =
        phalanx.status === 'Occupied' &&
        phalanx.connected_lance_tag_id !== NO_UID &&
        phalanx.connected_lance_tag_id &&
        phalanx.transaction_id !== NO_UID &&
        lance?.status !== 'Blocked';
      setCharging(charging);

      // Check for outdated timestamps
      const dtLastHeartbeat = moment.utc(
        phalanx.last_heartbeat_time,
        'YYYY-MM-DDTHH:mm:ss,Z'
      );
      const dtNow = moment.utc().local();
      const elapsedMilliseconds = moment.duration(dtNow.diff(dtLastHeartbeat))
        ._milliseconds;

      // Flag comms lost
      phalanx.no_heartbeat = elapsedMilliseconds >= 900 * 1000;

      let cartridge_id = 'Unknown';
      try {
        const cartridge = await servicesAPI.AdminServices(
          'getCartridge',
          phalanx_tag_id
        );
        cartridge_id = cartridge.cartridge_uid;
      } catch (error) {}

      let tableData = [
        {
          property: 'Tag Status',
          value: commissioning ? (
            <p style={{ color: 'red' }}>{'COMMISSIONING'}</p>
          ) : maintenance ? (
            <p style={{ color: 'red' }}>{'MAINTENANCE'}</p>
          ) : (
            phalanx.tag_status
          )
        },
        {
          property: 'Status',
          value: capped ? (
            'Capped'
          ) : muted ? (
            'Muted'
          ) : faulted ? (
            <p style={{ color: 'red' }}>{'Faulted'}</p>
          ) : charging ? (
            <p style={{ color: 'blue' }}>{'Charging'}</p>
          ) : (
            'Available'
          )
        },
        {
          property: 'Customer',
          value: who ? who : ''
        },
        {
          property: 'State',
          value: displayState(phalanx)
        },
        {
          property: 'Reference',
          value: phalanx.reference
        },
        {
          property: 'Cartridge Type',
          value:
            phalanx && phalanx.cart_model === 'NEW' ? (
              <p style={{ color: 'blue' }}>NEW</p>
            ) : (
              'Standard'
            )
        },
        {
          property: 'Cartridge ID',
          value: cartridge_id
        },
        // { property: 'Phalanx Tag ID', value: phalanxTagId },
        // { property: 'Reference', value: phalanx ? phalanx.reference : '' },
        // {
        //   property: 'Meter Tag ID',
        //   value: phalanx ? phalanx.meter_tag_id : ''
        // },
        // {
        //   property: 'Connected Lance Tag ID',
        //   value: phalanx ? phalanx.connected_lance_tag_id : ''
        // },
        // { property: 'Phase', value: phalanx ? phalanx.phase : '' },
        {
          property: 'Arbitrated Available Charge',
          value: phalanx ? phalanx.arbitrated_limit : ''
        }
      ];

      if (hydra?.project === 'SMARTSTEP') {
        tableData.push({
          property: 'SmartSTEP APC Limit (%)',
          value: phalanx ? phalanx.apc_limit : ''
        });
        tableData.push({
          property: 'SmartSTEP APC BOOST',
          value:
            phalanx && phalanx.boost === 1 ? (
              <p style={{ color: 'blue' }}>{'ACTIVE'}</p>
            ) : (
              '-'
            )
        });
      }

      tableData.push({
        property: 'Meter Tag ID',
        value: phalanx ? phalanx.meter_tag_id : ''
      });
      tableData.push({
        property: 'Latest Meter Reading',
        value: displayMeterReading(reading)
      });
      if (isAXON) {
        tableData.push({
          property: 'AXON Firmware Version',
          value: phalanx ? phalanx.axon_fw_version : ''
        });
      }
      tableData.push({
        property: 'Cartridge Firmware Version',
        value: phalanx ? phalanx.cart_fw_version : ''
      });
      tableData.push({
        property: 'Lance ID',
        value: displayLanceID(lance?.reference, lance?.lance_version)
      });
      tableData.push({
        property: 'Lance Firmware Version',
        value: phalanx ? phalanx.connected_lance_fw_version : ''
      });
      tableData.push({
        property: 'Last Heartbeat',
        value: phalanx?.no_heartbeat ? (
          <p style={{ color: 'red' }}>
            {dbUTCDatetimeToLocal(phalanx?.last_heartbeat_time)}
          </p>
        ) : (
          dbUTCDatetimeToLocal(phalanx?.last_heartbeat_time)
        )
      });
      tableData.push({
        property: 'Last Overnight Sump Pump Operation',
        value: dbUTCDatetimeToLocal(phalanx?.sump_pump_last_run_datetime)
      });
      tableData.push({
        property: 'Last Overnight Drive Motor Operation',
        value: dbUTCDatetimeToLocal(phalanx?.lock_last_run_datetime)
      });

      setTableData(tableData);
    } catch (error) {}
  }

  const displayMeterReading = reading => {
    // Check for outdated meter timestamp
    const dtLastReadingTimestamp = moment.utc(
      reading.timestamp,
      'YYYY-MM-DDTHH:mm:ss,Z'
    );
    const dtNow = moment.utc().local();
    const elapsedMilliseconds = moment.duration(
      dtNow.diff(dtLastReadingTimestamp)
    )._milliseconds;

    const lostMeterComms = elapsedMilliseconds >= 900 * 1000;

    const timestamp = lostMeterComms ? (
      <p style={{ color: 'red' }}>{dbUTCTimeToLocal(reading.timestamp)}</p>
    ) : (
      <p>{dbUTCTimeToLocal(reading.timestamp)}</p>
    );

    const energies = `L1=${reading.l1_energy}, L2=${reading.l2_energy}, L3=${reading.l3_energy}`;
    let currents = `L1=${reading.l1_current.toFixed(
      2
    )}, L2=${reading.l2_current.toFixed(2)}, L3=${reading.l3_current.toFixed(
      2
    )}`;
    if (reading.l1_current + reading.l2_current + reading.l3_current > 0)
      currents = (
        <>
          <span>L1=</span>
          <span style={{ color: 'blue' }}>{reading.l1_current.toFixed(2)}</span>
          <span>, L2=</span>
          <span style={{ color: 'blue' }}>{reading.l2_current.toFixed(2)}</span>
          <span>, L3=</span>
          <span style={{ color: 'blue' }}>{reading.l3_current.toFixed(2)}</span>
        </>
      );

    return (
      <>
        {timestamp}
        <p>energies({energies})</p>
        <p>currents({currents})</p>
      </>
    );
  };

  useEffect(() => {
    servicesAPI
      .InventoryServices('getPhalanxByReference', phalanxRef)
      .then(response => setPhalanx(response));
  }, [lastUpdated]);

  useEffect(() => {
    if (phalanx && !hydra) {
      getHydra();

      // If charging, get Lance info
      if (
        phalanx.connected_lance_tag_id &&
        phalanx.connected_lance_tag_id !== NO_UID &&
        !lance
      ) {
        servicesAPI
          .InventoryServices('getLance', phalanx.connected_lance_tag_id)
          .then(lance => setLance(lance));
      } else {
        setLance('');
      }
    }
  }, [phalanx]);

  useEffect(() => {
    if (!hydra) return;
    setIsAXON(hydra?.project === 'AXON' || hydra?.project === 'AON');
    setIsAON(hydra?.project === 'AON');
  }, [hydra]);

  useEffect(() => {
    if (lance) setIsLanceV2(isV2LanceID(lance?.reference));
  }, [lance]);

  useEffect(() => {
    if (hydra && phalanx) {
      getWhoWhatWhere(hydra, phalanx);
    }
  }, [hydra, phalanx]);

  useEffect(() => {
    if (hydra && phalanx && lance !== null && who != null)
      getData(phalanx.tag_id, phalanx.meter_tag_id);
  }, [hydra, phalanx, lance, who]);

  useEffect(() => {
    const valid = /^[0-9a-fA-F][0-9a-fA-F]([0-9a-fA-F][0-9a-fA-F])*$/.test(
      messageByteString
    );
    const numBytes = messageByteString.length / 2;

    setMessageByteStringValid(valid && messageLength >= numBytes - 1);
  }, [messageLength, messageByteString]);

  useEffect(() => {
    if (orionsHide || !phalanx || orionTypes === null || orions !== null)
      return;

    servicesAPI
      .AdminServices('getOrionsByPhalanx', phalanx.tag_id)
      .then(orions => {
        setOrions(
          orions.map(o => {
            const eventType = orionTypes.event_types.find(
              t => t.id === o.event_type_id
            );
            const ticketType = orionTypes.ticket_types.find(
              t => t.id === o.ticket_type_id
            );
            return {
              ...o,
              event_type: eventType ? eventType.name : 'Unknown',
              ticket_type: ticketType ? ticketType.name : 'Unknown',
              records: null,
              loading: false
            };
          })
        );
      });
  }, [orionsHide, phalanx, orionTypes, orions]);

  useEffect(() => {
    if (orionsHide || orionTypes !== null) return;

    // TDTODO cache these
    servicesAPI
      .AdminServices('getOrionTypes')
      .then(types => setOrionTypes(types));
  }, [orionsHide, orionTypes]);

  const confirmSendCommand = (command, params, confirmation, reroute) => {
    setIsModalOpen(true);
    setCommand(command);
    setParams(params);
    setConfirmation(confirmation);
    setRerouteCommand(reroute);
  };

  const sendCommand = () => {
    setIsModalOpen(false);

    const timestamp = moment.utc().format('YYYY-MM-DDTHH:mm:ss') + ',Z';

    if (command === 'REFRESH_PHALANX_CACHE') {
      servicesAPI
        .InventoryServices('getPhalanxByReference', phalanx.reference, true)
        .then(response => {
          dispatch(
            setToast({
              title: 'Cache refreshed!',
              body: ''
            })
          );
        });
    }

    if (
      [
        'STATUS_ACTIVE',
        'STATUS_MAINTENANCE',
        'CAP_CHARGE_STATION',
        'UNCAP_CHARGE_STATION'
      ].includes(command)
    ) {
      let values = {};
      if (command.startsWith('STATUS_')) {
        values = {
          tag_status: command === 'STATUS_ACTIVE' ? 'ACTIVE' : 'MAINTENANCE'
        };
      } else {
        values = {
          status: command === 'CAP_CHARGE_STATION' ? 'Capped' : 'Available'
        };
      }

      servicesAPI
        .InventoryServices(
          'updatePhalanxByReference',
          values,
          phalanx.reference
        )
        .then(
          response => {
            dispatch(
              setToast({
                title: 'Charge station updated!',
                body: ''
              })
            );
            servicesAPI.AdminServices(
              'auditUserActivity',
              {
                entity_type: 'PHALANX',
                entity_id: phalanx.reference,
                activity: 'SupportOperation',
                notes: `${where}: ${commandToText(command)}`,
                email_subject: '',
                email_body: ''
              },
              currentUser.id
            );
          },
          error => {}
        );

      if (command === 'CAP_CHARGE_STATION') {
        // Update the cartidge id
        values = {
          phalanx_tag_id: phalanx.tag_id,
          cartridge_id: 'CAPPED'
        };
        servicesAPI.AdminServices('updateCartridgeId', values);
      }
    } else if (
      isAXON &&
      (command === 'MUTE_CHARGE_STATION' || command === 'UNMUTE_CHARGE_STATION')
    ) {
      const values = {
        status: command === 'MUTE_CHARGE_STATION' ? 'Stopped' : 'Available'
      };
      servicesAPI
        .InventoryServices(
          'updatePhalanxByReference',
          values,
          phalanx.reference
        )
        .then(
          response => {
            dispatch(
              setToast({
                title: 'Charge station updated!',
                body: ''
              })
            );
            servicesAPI.AdminServices(
              'auditUserActivity',
              {
                entity_type: 'PHALANX',
                entity_id: phalanx.reference,
                activity: 'SupportOperation',
                notes: `${where}: ${commandToText(command)}`,
                email_subject: '',
                email_body: ''
              },
              currentUser.id
            );
          },
          error => {}
        );
      // Route message via an available charge station
    } else if (rerouteCommand) {
      servicesAPI
        .InventoryServices('getHydraPhalanxes', phalanx.hydra_tag_id)
        .then(
          phalanxes => {
            let availablePhalanxes = [];
            phalanxes.forEach(p => {
              if (
                !p.reference.endsWith('cs_00') &&
                p.reference !== phalanx.reference &&
                p.status === 'Available'
              )
                availablePhalanxes.push(p);
            });

            if (availablePhalanxes.length) {
              const availablePhalanx =
                availablePhalanxes[
                  Math.floor(Math.random() * availablePhalanxes.length)
                ];

              const csId = phalanx.reference.slice(-2);
              const values = {
                csms_command: command + '_' + csId + ',' + timestamp
              };
              servicesAPI
                .InventoryServices(
                  'updatePhalanxByReference',
                  values,
                  availablePhalanx.reference
                )
                .then(
                  response => {
                    const csId = availablePhalanx.reference.slice(-2);
                    dispatch(
                      setToast({
                        title: `Command sent to HUB via CS${csId}!`,
                        body: 'Check Google Cloud logs to confirm'
                      })
                    );
                    servicesAPI.AdminServices(
                      'auditUserActivity',
                      {
                        entity_type: 'PHALANX',
                        entity_id: phalanx.reference,
                        activity: 'SupportOperation',
                        notes: `${where}: ${commandToText(command)}`,
                        email_subject: '',
                        email_body: ''
                      },
                      currentUser.id
                    );
                  },
                  error => {}
                );
            }
          },
          error => {}
        );
    } else {
      let cmd = command;
      if (params.length) cmd += '_' + params.join('_');

      const values = {
        csms_command: cmd + ',' + timestamp
      };
      servicesAPI
        .InventoryServices(
          'updatePhalanxByReference',
          values,
          phalanx.reference
        )
        .then(
          response => {
            dispatch(
              setToast({
                title: 'Command sent to HUB!',
                body: 'Check Google Cloud logs to confirm'
              })
            );
            servicesAPI.AdminServices(
              'auditUserActivity',
              {
                entity_type: 'PHALANX',
                entity_id: phalanx.reference,
                activity: 'SupportOperation',
                notes: `${where}: ${commandToText(command)}`,
                email_subject: '',
                email_body: ''
              },
              currentUser.id
            );
          },
          error => {}
        );
    }
  };

  return (
    <Segment>
      <Grid stretched>
        <Grid.Row>
          <Grid.Column>
            <Header
              as="h2"
              onClick={() => {
                const hubRef = hydra.reference.split('_cs_')[0];
                history.push(`/admin/hubs/${hubRef}`);
              }}
            >
              Charge Point: {where}
            </Header>
          </Grid.Column>
        </Grid.Row>
      </Grid>
      <Divider hidden />
      <Divider hidden />
      <Grid>
        <Accordion>
          <Accordion.Title
            active={!statusHide}
            index={0}
            onClick={() => {
              setStatusHide(!statusHide);
            }}
          >
            <Header as="h2">
              <Icon name="dropdown" />
              Status
            </Header>
          </Accordion.Title>
          <Accordion.Content active={!statusHide}>
            <Table
              basic="very"
              selectable
              stackable
              renderBodyRow={({ property, value }, idx) => ({
                key: idx,
                cells: [
                  {
                    key: 'property',
                    onClick: () => {
                      copyToClipboard(property);

                      const bits = phalanx.reference.split('_cs');
                      const hubRef = bits[0];
                      const csId = 'cs' + bits[1];

                      history.push(`/admin/hubs/${hubRef}/${csId}`);
                    },
                    content: property
                  },
                  {
                    key: 'value',
                    onClick: () => {
                      copyToClipboard(value);

                      const bits = phalanx.reference.split('_cs');
                      const hubRef = bits[0];
                      const csId = 'cs' + bits[1];

                      if (property !== 'reference')
                        history.push(`/admin/hubs/${hubRef}/${csId}`);
                    },
                    content:
                      value === 'FAULTED' ? (
                        <p style={{ color: 'red' }}>{value}</p>
                      ) : (
                        value
                      )
                  }
                ]
              })}
              tableData={tableData}
            />
            {charging && (
              <Button
                onClick={() => {
                  servicesAPI
                    .MeteringServices(
                      'getLatestSessionByPhalanx',
                      phalanx.tag_id
                    )
                    .then(session => {
                      history.push(`/admin/session/${session.id}`);
                    });
                }}
                color="olive"
                disabled={!currentUserCan('ViewActiveSession')}
              >
                View Active Session
              </Button>
            )}
            {currentUserCan('ViewAllSessions') ? (
              <Button
                onClick={() => {
                  const bits = phalanx.reference.split('_cs');
                  const hubRef = bits[0];
                  const csId = 'cs' + bits[1];

                  history.push(`/admin/hubs/${hubRef}/${csId}/sessions`);
                }}
                color="olive"
                disabled={!currentUserCan('ManageActiveSession')}
              >
                Session History
              </Button>
            ) : (
              ''
            )}
            <Divider hidden />
          </Accordion.Content>
          <Accordion.Title
            active={!orionsHide}
            index={0}
            onClick={() => {
              setOrionsHide(!orionsHide);
            }}
          >
            <Header as="h2">
              <Icon name="dropdown" />
              ORION Tickets
            </Header>
          </Accordion.Title>
          <Accordion.Content active={!orionsHide}>
            <Grid>
              <Grid.Column>
                {orions && orions.length > 0
                  ? orions.map(o => (
                      <Grid.Row>
                        <b>Ticket no.: </b>
                        {linkifyText(`${o.ticket_number}#${o.id}`)}
                        <br />
                        <b>Ticket type:</b> {o.ticket_type}
                        <br />
                        <b>Event type:</b> {o.event_type}
                        <br />
                        <b>Created:</b>{' '}
                        {dbUTCDatetimeToLocal2(o.created_datetime)}
                        <br />
                        <b>Status:</b> {o.status}
                        <br />
                        {o.records === null ? (
                          <p
                            onClick={() => {
                              o.loading = true;
                              setRefresh(!refresh);
                              servicesAPI
                                .AdminServices('getOrionRecords', o.id)
                                .then(records => {
                                  o.records = records;
                                  o.loading = false;
                                  setOrions(orions);
                                  setRefresh(!refresh);
                                });
                            }}
                          >
                            <b>Details:</b>{' '}
                            {o.loading ? 'Loading...' : '(click to load)'}
                          </p>
                        ) : (
                          <>
                            <b>Details:</b>
                            <br />
                            {o.records.map(r => (
                              <>
                                {dbUTCDatetimeToLocal2(r.record_datetime)}:{' '}
                                {r.record_details} - (added by {r.modified_by}
                                )
                                <br />
                              </>
                            ))}
                          </>
                        )}
                        {/*<Button
                          onClick={() => {
                            const orionReporter = getOrionReporter(
                              currentUser.user_name
                            );
                            const values = {
                              reporter: orionReporter,
                              short_description: orionNotes,
                              modified_by: orionReporter
                            };
                            servicesAPI
                              .AdminServices('addOrionRecord', o.id, values)
                              .then(
                                response => {
                                  displayMessage(
                                    'Success',
                                    'Details added to Orion ticket',
                                    true
                                  );
                                },
                                error => {
                                  displayMessage(
                                    'Error',
                                    'Failed to add details to Orion ticket',
                                    false
                                  );
                                }
                              );
                          }}
                          color="olive"
                        >
                          Update Ticket (with details below)
                        </Button>*/}
                        <br />
                      </Grid.Row>
                    ))
                  : 'No tickets.'}
              </Grid.Column>
            </Grid>
            {/*<br />
            <b>New details:</b>
            <br />
            <TextArea
              value={orionNotes}
              onChange={(e, inputProps) => setOrionNotes(inputProps.value)}
              style={{ minWidth: 300, minHeight: 100 }}
            />
            <br />
            <Button
              onClick={() => {
                const date = moment().format('DD/MM/YYYY');
                const time = moment().format('HH:mm');

                const y = date.substring(6, 10);
                const m = date.substring(3, 5);
                const d = date.substring(0, 2);
                const timestamp = `${y}-${m}-${d} ${time}`;

                const values = {
                  timestamp: timestamp,
                  customer_id: customer ? customer.customer_id : '',
                  lance_tag_id: phalanx
                    ? phalanx.connected_lance_tag_id
                    : '',
                  hydra_tag_id: phalanx ? phalanx.hydra_tag_id : '',
                  phalanx_tag_id: phalanx ? phalanx.tag_id : '',
                  details: orionNotes,
                  lance_top_lights: 'Unknown',
                  edge_lights: 'Unknown'
                };

                servicesAPI.AdminServices('createOrion', values).then(
                  response => {
                    displayMessage('Success', 'Orion ticket created', true);
                  },
                  error => {
                    displayMessage(
                      'Error',
                      'Error creating Orion ticket',
                      false
                    );
                  }
                );
              }}
              color="olive"
            >
              Create Ticket (with above details)
            </Button>
            <br />*/}
          </Accordion.Content>
          <Accordion.Title
            active={!statesHide}
            index={0}
            onClick={() => {
              setStatesHide(!statesHide);
            }}
          >
            <Header as="h2">
              <Icon name="dropdown" />
              States
            </Header>
          </Accordion.Title>
          <Accordion.Content active={!statesHide}>
            {phalanx ? (
              <ChargingSessionStates
                phalanxTagId={phalanx.tag_id}
                phalanxRef={phalanx.reference}
                lance={lance}
                isAXON={isAXON}
                setLanceDetected={setLanceDetected}
                lastUpdated={lastUpdated}
                setLastUpdated={setLastUpdated}
              />
            ) : (
              ''
            )}
            <Divider hidden />
          </Accordion.Content>
          {currentUserCan('DoAllTheThings') && (
            <>
              <Header as="h2">Portal</Header>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'REFRESH_DASHBOARD',
                    [],
                    where +
                      ': Are you sure you want to refresh the dashboard for this charge station?',
                    false
                  );
                }}
                color="olive"
              >
                Refresh Dashboard Status
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'REFRESH_PHALANX_CACHE',
                    [],
                    where +
                      ': Are you sure you want to refresh the cache to match inventory.phalanx?',
                    false
                  );
                }}
                color="olive"
              >
                Copy DB Phalanx To Cache
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'REFRESH_READING_CACHE',
                    [],
                    where +
                      ': Are you sure you want to refresh the cache to match meter.reading?',
                    false
                  );
                }}
                color="olive"
              >
                Copy DB Reading To Cache
              </Button>
              {currentUserIsDebug && (
                <>
                  <Button
                    onClick={() => {
                      confirmSendCommand(
                        'OVERRIDE_TO_IDLING',
                        [],
                        where +
                          ': Are you sure you want to force the charge station`s status to idling?',
                        false
                      );
                    }}
                    color="olive"
                  >
                    Force To Idling
                  </Button>
                </>
              )}
              <br />
              <br />
            </>
          )}
          <Header as="h2">Cartridge & Lance</Header>
          {isAXON ? (
            <>
              <Popup
                content={`Only available in ${
                  isLanceV2
                    ? 'WaitingButtonPressedState'
                    : 'WaitingPoleDroppedState'
                }`}
                style={{ float: 'right' }}
                trigger={
                  <span>
                    <Button
                      onClick={() => {
                        confirmSendCommand(
                          'RE_AUTHORISE',
                          [],
                          where +
                            ': Are you sure you want to reauthorise the Lance? ' +
                            what,
                          false
                        );
                      }}
                      color="olive"
                      disabled={
                        !currentUserCan('ManageCartridge') ||
                        phalanx?.status === 'Capped' ||
                        ![
                          'WaitingButtonPressedState',
                          'WaitingPoleDroppedState'
                        ].includes(phalanx?.current_state)
                      }
                    >
                      Reauthorise Lance
                    </Button>
                  </span>
                }
              />
              <Popup
                content="Only available in ManagingMessState with Lance present"
                style={{ float: 'right' }}
                trigger={
                  <span>
                    <Button
                      onClick={() => {
                        confirmSendCommand(
                          'RE_LANCE_INIT',
                          [],
                          where +
                            ': Are you sure you want to reinitialise the Lance? ' +
                            what,
                          false
                        );
                      }}
                      color="olive"
                      disabled={
                        !currentUserCan('ManageCartridge') ||
                        phalanx?.status === 'Capped' ||
                        phalanx?.current_state !== 'ManagingMessState' ||
                        !lanceDetected
                      }
                    >
                      Reinitialise Lance
                    </Button>
                  </span>
                }
              />
              <br />
              <br />
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'EXIT_LOCK_FAILED',
                    [],
                    where +
                      ': Are you sure you want to exit LockMoveFailedState? If the lock failed while opening with a lance present, THIS WILL EJECT THE LANCE. ' +
                      what,
                    false
                  );
                }}
                color="red"
                disabled={
                  phalanx?.status === 'Capped' ||
                  phalanx?.current_state !== 'LockMoveFailedState' ||
                  !currentUserCan('ManageCartridge')
                }
              >
                Exit LockMoveFailedState
              </Button>
              <br />
              <br />
            </>
          ) : (
            ''
          )}
          <Popup
            content="Not available in Disabled, B2 or C2 state"
            style={{ float: 'right' }}
            trigger={
              <span>
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'EJECT_LANCE',
                      [],
                      where +
                        ': Are you sure you want to eject the Lance? ' +
                        what,
                      false
                    );
                  }}
                  color="red"
                  disabled={
                    !currentUserCan('EjectLance') ||
                    phalanx?.status === 'Capped' ||
                    phalanx?.current_state === 'EvB2State' ||
                    phalanx?.current_state === 'EvC2State' ||
                    phalanx?.current_state === 'DisabledState'
                  }
                >
                  Eject Lance
                </Button>
              </span>
            }
          />
          <br />
          <br />
          {!isAXON ? (
            <>
              <Popup
                content="Not available in B2 or C2 state"
                style={{ float: 'right' }}
                trigger={
                  <span>
                    <Button
                      onClick={() => {
                        confirmSendCommand(
                          'LOCK_CARTRIDGE',
                          [],
                          where +
                            ': Are you sure you want to lock the Cartridge? ' +
                            what,
                          false
                        );
                      }}
                      color="olive"
                      disabled={
                        !currentUserCan('ManageCartridge') ||
                        phalanx?.status === 'Capped' ||
                        phalanx?.current_state === 'EvB2State' ||
                        phalanx?.current_state === 'EvC2State'
                      }
                    >
                      Lock Cartridge
                    </Button>
                  </span>
                }
              />
              <Popup
                content="Not available in B2 or C2 state"
                style={{ float: 'right' }}
                trigger={
                  <span>
                    <Button
                      onClick={() => {
                        confirmSendCommand(
                          'UNLOCK_CARTRIDGE',
                          [],
                          where +
                            ': Are you sure you want to unlock the Cartridge? ' +
                            what,
                          false
                        );
                      }}
                      color="red"
                      disabled={
                        !currentUserCan('ManageCartridge') ||
                        phalanx?.status === 'Capped' ||
                        phalanx?.current_state === 'EvB2State' ||
                        phalanx?.current_state === 'EvC2State'
                      }
                    >
                      Unlock Cartridge
                    </Button>
                  </span>
                }
              />
            </>
          ) : (
            <>
              <Popup
                content="Only available in DisabledState"
                style={{ float: 'right' }}
                trigger={
                  <span>
                    <Button
                      onClick={() => {
                        confirmSendCommand(
                          'LOCK_CARTRIDGE',
                          [],
                          where +
                            ': Are you sure you want to lock the Cartridge? ' +
                            what,
                          false
                        );
                      }}
                      color="olive"
                      disabled={
                        !currentUserCan('ManageCartridge') ||
                        phalanx?.status === 'Capped' ||
                        phalanx?.current_state !== 'DisabledState'
                      }
                    >
                      Lock Cartridge
                    </Button>
                  </span>
                }
              />
              <Popup
                content="Only available in DisabledState"
                style={{ float: 'right' }}
                trigger={
                  <span>
                    <Button
                      onClick={() => {
                        confirmSendCommand(
                          'UNLOCK_CARTRIDGE',
                          [],
                          where +
                            ': Are you sure you want to unlock the Cartridge? ' +
                            what,
                          false
                        );
                      }}
                      color="red"
                      disabled={
                        !currentUserCan('ManageCartridge') ||
                        phalanx?.status === 'Capped' ||
                        phalanx?.current_state !== 'DisabledState'
                      }
                    >
                      Unlock Cartridge
                    </Button>
                  </span>
                }
              />
            </>
          )}
          {currentUserCan('MaintainChargePoint') ? (
            <>
              <br />
              <br />
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'ENABLE_HEATER',
                    [],
                    where +
                      ': Are you sure you want to enable trace heating? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={
                  !currentUserCan('ManageCartridge') ||
                  phalanx?.status === 'Capped'
                }
              >
                Enable Trace Heating
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'DISABLE_HEATER',
                    [],
                    where +
                      ': Are you sure you want to disable trace heating? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={
                  !currentUserCan('ManageCartridge') ||
                  phalanx?.status === 'Capped'
                }
              >
                Disable Trace Heating
              </Button>
            </>
          ) : (
            ''
          )}
          {isAXON || isAON ? (
            <>
              <br />
              <br />
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'RESET_SUMP_PUMP',
                    [],
                    where +
                      ': Are you sure you want to reset the sump pump? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={
                  !currentUserCan('ManageCartridge') ||
                  phalanx?.status === 'Capped'
                }
              >
                Reset Sump Pump
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'DRIVE_SUMP_PUMP',
                    [],
                    where +
                      ': Are you sure you want to drive the sump pump? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={
                  !currentUserCan('ManageSumpPump') ||
                  phalanx?.status === 'Capped'
                }
              >
                Drive Sump Pump
              </Button>
            </>
          ) : (
            ''
          )}
          {!isAXON ? (
            <>
              <br />
              <br />
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'CARTRIDGE_INFO',
                    [],
                    where +
                      ': Are you sure you want to get the Cartridge firmware version and UID? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={
                  !currentUserCan('ManageCartridge') ||
                  phalanx?.status === 'Capped'
                }
              >
                Get Cartridge Info
              </Button>
            </>
          ) : (
            ''
          )}
          <br />
          <Header as="h2">EV Charging Profile</Header>
          <Button
            onClick={() => {
              confirmSendCommand(
                'SET_CHARGE_0',
                [],
                where +
                  ': Are you sure you want to set the charge rate to 0A? ' +
                  what,
                false
              );
            }}
            color="olive"
            disabled={!currentUserCan('ManageActiveSession')}
          >
            Set to B1 State
          </Button>
          <Button
            onClick={() => {
              confirmSendCommand(
                'SET_CHARGE_6',
                [],
                where +
                  ': Are you sure you want to set the charge rate to 6A? ' +
                  what,
                false
              );
            }}
            color="olive"
            disabled={!currentUserCan('ManageActiveSession')}
          >
            Set charge profile to 6A
          </Button>
          <Button
            onClick={() => {
              confirmSendCommand(
                'SET_CHARGE_20',
                [],
                where +
                  ': Are you sure you want to set the charge rate to 20A? ' +
                  what,
                false
              );
            }}
            color="olive"
            disabled={!currentUserCan('ManageActiveSession')}
          >
            Set charge profile to 20A
          </Button>
          <Button
            onClick={() => {
              confirmSendCommand(
                'SET_CHARGE_32',
                [],
                where +
                  ': Are you sure you want to set the charge rate to 32A? ' +
                  what,
                false
              );
            }}
            color="olive"
            disabled={!currentUserCan('ManageActiveSession')}
          >
            Set charge profile to 32A
          </Button>
          <br />
          <br />
          <Button
            onClick={() => {
              confirmSendCommand(
                'CLEAR_CHARGE_OVERRIDE',
                [],
                'Are you sure you want to revert to arbitrated charging?',
                false
              );
            }}
            color="olive"
            disabled={!currentUserCan('ManageActiveSession')}
          >
            Auto charge profile
          </Button>
          <br />
          <Header as="h2">Charge Station</Header>
          <Button
            onClick={() => {
              confirmSendCommand(
                'START_CHARGE_STATION',
                [],
                where +
                  ': Are you sure you want to start the charge station? ' +
                  what,
                !isAXON
              );
            }}
            color="olive"
            disabled={
              !currentUserCan('ManageChargePoint') ||
              phalanx?.status === 'Capped'
            }
          >
            Start charge station
          </Button>
          <Button
            onClick={() => {
              confirmSendCommand(
                'STOP_CHARGE_STATION',
                [],
                where +
                  ': Are you sure you want to stop the charge station? ' +
                  what,
                false
              );
            }}
            color="olive"
            disabled={
              !currentUserCan('ManageChargePoint') ||
              phalanx?.status === 'Capped'
            }
          >
            Stop charge station
          </Button>
          {!isAXON ? (
            <Button
              onClick={() => {
                confirmSendCommand(
                  'RESTART_CHARGE_STATION',
                  [],
                  where +
                    ': Are you sure you want to restart the charge station? ' +
                    what,
                  false
                );
              }}
              color="olive"
              disabled={
                !currentUserCan('ManageChargePoint') ||
                phalanx?.status === 'Capped'
              }
            >
              Restart charge station
            </Button>
          ) : (
            ''
          )}
          {currentUserCan('DoAllTheThings') && isAXON ? (
            <>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'RESTART_CHARGE_STATION',
                    [],
                    where +
                      ': This should only be used as a last resort. Are you sure you want to restart the charge station? ' +
                      what,
                    false
                  );
                }}
                color="red"
                disabled={phalanx?.status === 'Capped'}
              >
                {currentUser.user_name === 'sandy'
                  ? 'PLAN J (Restart charge station)'
                  : 'Restart charge station'}
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'BLOCK_REBOOTS',
                    [],
                    where +
                      ': Are you sure you want to block reboots on the charge station? ' +
                      what,
                    false
                  );
                }}
                color="red"
                disabled={phalanx?.status === 'Capped'}
              >
                Block reboots
              </Button>
              <br />
              <br />
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'ENABLE_DEBUG',
                    [],
                    where +
                      ': Are you sure you want to enable debugging? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={phalanx?.status === 'Capped'}
              >
                Enable debugging
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'DISABLE_DEBUG',
                    [],
                    where +
                      ': Are you sure you want to disable debugging? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={phalanx?.status === 'Capped'}
              >
                Disable debugging
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'SEND_LOOPBACK',
                    [],
                    where +
                      ': Are you sure you want to send a loopback message? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={phalanx?.status === 'Capped'}
              >
                Send loopback message
              </Button>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'CLOSE_WEBSOCKET',
                    [],
                    where +
                      ': Are you sure you want to close the websocket connection? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={phalanx?.status === 'Capped'}
              >
                Close websocket
              </Button>
            </>
          ) : (
            ''
          )}
          <br />
          <br />
          <Button
            onClick={() => {
              confirmSendCommand(
                'UNMUTE_CHARGE_STATION',
                [],
                where +
                  ': Are you sure you want to unmute the charge station? ' +
                  what,
                true
              );
            }}
            color="olive"
            disabled={
              !currentUserCan('ManageChargePoint') ||
              phalanx?.status === 'Capped'
            }
          >
            Unmute charge station
          </Button>
          <Button
            onClick={() => {
              confirmSendCommand(
                'MUTE_CHARGE_STATION',
                [],
                where +
                  ': Are you sure you want to mute the charge station? ' +
                  what,
                true
              );
            }}
            color="olive"
            disabled={
              !currentUserCan('ManageChargePoint') ||
              phalanx?.status === 'Capped'
            }
          >
            Mute charge station
          </Button>
          <br />
          <br />
          {currentUserCan('MaintainChargePoint') &&
          phalanx?.tag_status === 'COMMISSIONING' ? (
            <>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'STATUS_ACTIVE',
                    [],
                    where +
                      ': Are you sure you want to make the charge station active? ' +
                      what,
                    true
                  );
                }}
                color="olive"
              >
                Exit commissioning mode
              </Button>
              <br />
              <br />
            </>
          ) : (
            ''
          )}
          {currentUserCan('MaintenanceMode') &&
          phalanx?.tag_status !== 'COMMISSIONING' ? (
            <>
              {phalanx?.tag_status === 'MAINTENANCE' ? (
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'STATUS_ACTIVE',
                      [],
                      where +
                        ': Are you sure you want to make the charge station active? ' +
                        what,
                      true
                    );
                  }}
                  color="olive"
                >
                  Exit maintenance mode
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'STATUS_MAINTENANCE',
                      [],
                      where +
                        ': Are you sure you want to put the charge station into maintenance mode? ' +
                        what,
                      true
                    );
                  }}
                  color="olive"
                >
                  Enter maintenance mode
                </Button>
              )}
              <br />
              <br />
            </>
          ) : (
            ''
          )}
          {currentUserCan('CapChargePoint') ? (
            <>
              {phalanx?.status !== 'Capped' ? (
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'CAP_CHARGE_STATION',
                      [],
                      where +
                        ': Are you sure you want to cap this charge station?',
                      false
                    );
                  }}
                  color="olive"
                >
                  Cap charge station
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'UNCAP_CHARGE_STATION',
                      [],
                      where +
                        ': Are you sure you want to uncap this charge station?',
                      false
                    );
                  }}
                  color="olive"
                >
                  Uncap charge station
                </Button>
              )}
              <br />
              <br />
            </>
          ) : (
            ''
          )}
          <Form>
            {currentUserCan('DoAllTheThings') && isAXON ? (
              <>
                <Header as="h2">Request Data</Header>
                <Segment style={{ width: '300px' }}>
                  <Form.Dropdown
                    selection
                    label={'Data Type'}
                    options={dataRequestOptions}
                    onChange={(e, inputProps) =>
                      setDataRequest(inputProps.value)
                    }
                    value={dataRequest}
                    style={{ width: '250px' }}
                  />
                  <Button
                    onClick={() => {
                      let command = 'DATA_REQUEST_' + dataRequest;

                      confirmSendCommand(
                        command,
                        [],
                        where +
                          ': Are you sure you want to request this data? ' +
                          what,
                        false
                      );
                    }}
                    color="olive"
                    disabled={
                      !currentUserCan('ManageCartridge') ||
                      phalanx?.status === 'Capped'
                    }
                  >
                    Send request
                  </Button>
                </Segment>
              </>
            ) : (
              ''
            )}
          </Form>
          <Header as="h2">LED Presets</Header>
          {!isAXON ? (
            <>
              <Button
                onClick={() => {
                  confirmSendCommand(
                    'SET_CARTRIDGE_LEDS_RED',
                    [],
                    where +
                      ': Are you sure you want to set charge station LEDs to red? ' +
                      what,
                    false
                  );
                }}
                color="olive"
                disabled={
                  !currentUserCan('ManageCartridge') ||
                  phalanx?.status === 'Capped'
                }
              >
                Set charge station LEDs to red
              </Button>
              <br />
            </>
          ) : (
            ''
          )}
          <Form>
            {currentUserCan('MaintainChargePoint') && isAXON ? (
              <>
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'SET_CARTRIDGE_LEDS_DEFAULT',
                      [],
                      where +
                        ': Are you sure you want to set the cartridge LEDs to its defaults? ' +
                        what,
                      false
                    );
                  }}
                  color="olive"
                  disabled={
                    !currentUserCan('ManageCartridge') ||
                    phalanx?.status === 'Capped'
                  }
                >
                  Cartridge: default values
                </Button>
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'SET_LANCE_LEDS_DEFAULT',
                      [],
                      where +
                        ': Are you sure you want to set the Lance LEDs to its defaults? ' +
                        what,
                      false
                    );
                  }}
                  color="olive"
                  disabled={
                    !currentUserCan('ManageCartridge') ||
                    phalanx?.status === 'Capped'
                  }
                >
                  Lance: default values
                </Button>
              </>
            ) : (
              ''
            )}
            <br />
            {currentUserCan('MaintainChargePoint') && isAXON ? (
              <>
                <Header as="h2">Set LEDs</Header>
                <Segment style={{ width: '300px' }}>
                  <Form.Dropdown
                    selection
                    label={'Cartridge / Lance'}
                    options={ledCartridgeLanceOptions}
                    onChange={(e, inputProps) =>
                      setLedCartridgeLance(inputProps.value)
                    }
                    value={ledCartridgeLance}
                    style={{ width: '150px' }}
                  />
                  <Form.Dropdown
                    selection
                    label={ledCartridgeLance ? 'White / RGB' : 'Location'}
                    options={
                      ledCartridgeLance
                        ? ledLanceSetOptions
                        : ledCartidgeSetOptions
                    }
                    onChange={(e, inputProps) => setLedSet(inputProps.value)}
                    value={ledSet}
                    style={{ width: '150px' }}
                  />
                  <Form.Dropdown
                    selection
                    label={'Colour'}
                    options={ledColourOptions}
                    onChange={(e, inputProps) => {
                      const colour = inputProps.value;
                      if (colour === 0) {
                        setLedOnTime(0);
                        setLedOffTime(15);
                      }
                      setLedColour(colour);
                    }}
                    value={ledColour}
                    style={{ width: '150px' }}
                  />
                  <Form.Dropdown
                    selection
                    label={'Solid / Flashing'}
                    options={ledSolidFlashingOptions}
                    onChange={(e, inputProps) =>
                      setLedSolidFlashing(inputProps.value)
                    }
                    value={ledSolidFlashing}
                    style={{ width: '150px' }}
                  />
                  {ledSolidFlashing ? (
                    <>
                      <Input
                        type="number"
                        label={'Flash On Time (0-15s)'}
                        name="ontime"
                        value={ledOnTime}
                        onChange={(e, inputProps) =>
                          setLedOnTime(
                            Math.min(
                              Math.max(parseInt(inputProps.value), 0),
                              15
                            )
                          )
                        }
                        style={{ width: '150px' }}
                        disabled={ledColour === 0}
                      />
                      <br />
                      <br />
                      <Input
                        type="number"
                        label={'Flash Off Time (0-15s)'}
                        name="offtime"
                        value={ledOffTime}
                        onChange={(e, inputProps) =>
                          setLedOffTime(
                            Math.min(
                              Math.max(parseInt(inputProps.value), 0),
                              15
                            )
                          )
                        }
                        style={{ width: '150px' }}
                        disabled={ledColour === 0}
                      />
                      <br />
                      <br />
                    </>
                  ) : (
                    ''
                  )}
                  <Input
                    type="number"
                    label={'Brightness (0-1023)'}
                    name="brightness"
                    value={ledBrightness}
                    onChange={(e, inputProps) =>
                      setLedBrightness(
                        Math.min(Math.max(parseInt(inputProps.value), 0), 1023)
                      )
                    }
                    style={{ width: '100px' }}
                  />
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      let command = 'SET_LEDS_';
                      command += ledCartridgeLance ? 'L' : 'C';
                      command += ledSet;
                      command += ledColour;
                      command += ledSolidFlashing ? toHex(ledOnTime, 2) : '0F';
                      command += ledSolidFlashing ? toHex(ledOffTime, 2) : '00';
                      command += toHex(ledBrightness, 3);

                      confirmSendCommand(
                        command,
                        [],
                        where +
                          ': Are you sure you want to apply these LED settings? ' +
                          what,
                        false
                      );
                    }}
                    color="olive"
                    disabled={
                      !currentUserCan('ManageCartridge') ||
                      phalanx?.status === 'Capped'
                    }
                  >
                    Apply LED settings
                  </Button>
                </Segment>
                <Segment style={{ width: '430px' }}>
                  <Button
                    onClick={() => {
                      confirmSendCommand(
                        'HUB_ENABLE_MODBUS_SERVER_PAUSE_DURING_METER_READS',
                        [1],
                        where +
                          ': Are you sure you want to enable Modbus server pause during meter reads? ' +
                          what,
                        false
                      );
                    }}
                    color="olive"
                    disabled={phalanx?.status === 'Capped'}
                  >
                    Enable Modbus server pause during meter reads
                  </Button>
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      confirmSendCommand(
                        'HUB_ENABLE_MODBUS_SERVER_PAUSE_DURING_METER_READS',
                        [0],
                        where +
                          ': Are you sure you want to disable Modbus server pause during meter reads? ' +
                          what,
                        false
                      );
                    }}
                    color="olive"
                    disabled={phalanx?.status === 'Capped'}
                  >
                    Disable Modbus server pause during meter reads
                  </Button>
                </Segment>
                {isAON ? (
                  <>
                    <Header as="h2">LTE Modem</Header>
                    <Segment style={{ width: '430px' }}>
                      <Input
                        type="number"
                        label={'LTE modem power down expiry timer(s)'}
                        value={modemPowerDownExpiryTimer}
                        onChange={(e, inputProps) =>
                          setModemPowerDownExpiryTimer(
                            Math.max(parseInt(inputProps.value), 0)
                          )
                        }
                        style={{ width: '100px' }}
                      />
                      <br />
                      <br />
                      <Button
                        onClick={() => {
                          confirmSendCommand(
                            'POWER_DOWN_LTE_MODEM',
                            [modemPowerDownExpiryTimer],
                            where +
                              ': Are you sure you want to power down the LTE modem? ' +
                              what,
                            false
                          );
                        }}
                        color="olive"
                        disabled={phalanx?.status === 'Capped'}
                      >
                        Power down LTE modem
                      </Button>
                    </Segment>
                  </>
                ) : (
                  ''
                )}
                <Button
                  onClick={() => {
                    confirmSendCommand(
                      'LTE4G_REPORT_ALTERNATIVE_CELL_TOWERS',
                      [],
                      where +
                        ': Are you sure you want to report alternative cell towers?',
                      false
                    );
                  }}
                  color="olive"
                  disabled={phalanx?.status === 'Capped'}
                >
                  Report alternative cell towers
                </Button>
                <br />
                <Segment style={{ width: '320px' }}>
                  <Input
                    type="number"
                    label={'Operator code (0=auto)'}
                    value={operatorCode}
                    onChange={(e, inputProps) =>
                      setOperatorCode(Math.max(parseInt(inputProps.value), 0))
                    }
                    style={{ width: '100px' }}
                  />
                  <br />
                  <br />
                  <Checkbox
                    toggle
                    label="Permanent"
                    checked={permanent}
                    onChange={e => {
                      setPermanent(!permanent);
                    }}
                  />
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      confirmSendCommand(
                        'LTE4G_SELECT_OPERATOR',
                        [operatorCode, permanent ? '1' : '0'],
                        where +
                          ': Are you sure you want to select LTE operator? ' +
                          what,
                        false
                      );
                    }}
                    color="olive"
                    disabled={phalanx?.status === 'Capped'}
                  >
                    Power down LTE modem
                  </Button>
                </Segment>
                <Header as="h2">Settings</Header>
                <Segment style={{ width: '340px' }}>
                  <Form.Dropdown
                    selection
                    label={'Setting type'}
                    options={settingTypeOptions}
                    onChange={(e, inputProps) =>
                      setSettingType(inputProps.value)
                    }
                    value={settingType}
                    style={{ width: '250px' }}
                  />
                  <Checkbox
                    toggle
                    label="Permanent"
                    checked={settingPermanent}
                    onChange={e => {
                      setSettingPermanent(!settingPermanent);
                    }}
                  />
                  <br />
                  <br />
                  <Input
                    type="number"
                    label={'Value length (bytes)'}
                    value={settingLength}
                    onChange={(e, inputProps) =>
                      setSettingLength(
                        Math.min(Math.max(parseInt(inputProps.value), 0), 255)
                      )
                    }
                    style={{ width: '100px' }}
                  />
                  <br />
                  <br />
                  <Input
                    type="text"
                    label={'Value (hex)'}
                    value={settingValue}
                    onChange={(e, inputProps) => {
                      const value = inputProps.value.toUpperCase();
                      const regExHex = /^[0-9A-F]*$/i;
                      const isHex = regExHex.test(value);

                      if (isHex) setSettingValue(value);
                    }}
                    style={{ width: '210px' }}
                  />
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      // If hex value has odd number of digits, prefix with 0
                      if (settingValue.length % 2 === 0)
                        setSettingValue('0' + settingValue);

                      confirmSendCommand(
                        'SETTINGS',
                        [
                          settingType,
                          settingPermanent ? '1' : '0',
                          settingLength,
                          settingValue
                        ],
                        where +
                          ': Are you sure you want to change the setting? ' +
                          what,
                        false
                      );
                    }}
                    color="olive"
                    disabled={phalanx?.status === 'Capped'}
                  >
                    Change settings
                  </Button>
                </Segment>
                <Header as="h2">General Message</Header>
                <Segment style={{ width: '340px' }}>
                  <Input
                    type="number"
                    label={'Length'}
                    value={messageLength}
                    onChange={(e, inputProps) =>
                      setMessageLength(
                        Math.min(Math.max(parseInt(inputProps.value), 0), 255)
                      )
                    }
                  />
                  <Input
                    label={'Hex bytes'}
                    style={{ width: '450px' }}
                    value={messageByteString}
                    onChange={(e, inputProps) =>
                      setMessageByteString(inputProps.value)
                    }
                  />
                  <br />
                  <br />
                  <Button
                    onClick={() => {
                      const messageParamString = messageByteString
                        .match(/.{2}/g)
                        .reverse()
                        .join('_');

                      confirmSendCommand(
                        'SEND_MESSAGE',
                        [messageLength, messageParamString],
                        'Are you sure you want to send this message?',
                        false
                      );
                    }}
                    color="olive"
                    disabled={!messageByteStringValid}
                  >
                    Send message
                  </Button>
                </Segment>
              </>
            ) : (
              ''
            )}
          </Form>
          {/*<Header as="h2">HUB & CSMS</Header>*/}
          {/*<Button
            onClick={() => {
              confirmSendCommand(
                'REQUEST_STATUS',
                [],
                'Are you sure you want to request the status?',
                false
              );
            }}
            color="olive"
          >
            Request status
          </Button>*/}
          {/*<Button
            onClick={() => {
              confirmSendCommand(
                'END_PHALANX_SESSION',
                [],
                where +
                  ': Are you sure you want to end an active charging session? ' +
                  what,
                false
              );
            }}
            color="olive"
            disabled={!currentUserCan('DoAllTheThings')}
          >
            End Charging Session
          </Button>*/}
          {/*<br />
          <br />
          <Button
            onClick={() => {
              confirmSendCommand(
                'RESET_QUEUE',
                [],
                'Are you sure you want to reset the websocket?',
                false
              );
            }}
            color="olive"
          >
            Reset websocket
          </Button>*/}
          <Modal open={isModalOpen} size="small" style={{ padding: '20px' }}>
            <Modal.Content>
              {confirmation}
              <br />
              <br />
              <br />
              <Button basic color="olive" onClick={sendCommand}>
                Yes
              </Button>
              <Button
                basic
                onClick={event => {
                  setIsModalOpen(false);
                }}
              >
                No
              </Button>
            </Modal.Content>
          </Modal>
          <Divider hidden />
        </Accordion>
      </Grid>
      {refresh ? '' : ''}
    </Segment>
  );
};
